const actions = {
    SETTING_READ_ALL_REQUEST: 'SETTING_READ_ALL_REQUEST',
    SETTING_READ_ALL_SUCCESS: 'SETTING_READ_ALL_SUCCESS',
    SETTING_READ_ALL_ERROR: 'SETTING_READ_ALL_ERROR',
    SETTING_UPDATE_MULTIPLE_REQUEST: 'SETTING_UPDATE_MULTIPLE_REQUEST',
    SETTING_UPDATE_MULTIPLE_SUCCESS: 'SETTING_UPDATE_MULTIPLE_SUCCESS',
    SETTING_UPDATE_MULTIPLE_ERROR: 'SETTING_UPDATE_MULTIPLE_ERROR',
    SETTING_UPDATE_API_REQUEST: 'SETTING_UPDATE_API_REQUEST',
    SETTING_UPDATE_API_SUCCESS: 'SETTING_UPDATE_API_SUCCESS',
    SETTING_UPDATE_API_ERROR: 'SETTING_UPDATE_API_ERROR',
    REFRESH_API_TOKEN_REQUEST: 'REFRESH_API_TOKEN_REQUEST',
    REFRESH_API_TOKEN_SUCCESS: 'REFRESH_API_TOKEN_SUCCESS',
    REFRESH_API_TOKEN_ERROR: 'REFRESH_API_TOKEN_ERROR',
    SETTING_CHANGE_ALL: 'SETTING_CHANGE_ALL',
    SETTING_CHANGE_SALES_TAX_ON: 'SETTING_CHANGE_SALES_TAX_ON',
    SETTING_CHANGE_SERVICE_TAX_ON: 'SETTING_CHANGE_SERVICE_TAX_ON',
    SETTING_CHANGE_SERVICE_TAX_ACCRUAL_BASIS_ON: 'SETTING_CHANGE_SERVICE_TAX_ACCRUAL_BASIS_ON',
    SETTING_CHANGE_SHOW_EXEMPTED_TAX_CODES: 'SETTING_CHANGE_SHOW_EXEMPTED_TAX_CODES',
    SETTING_CHANGE_FORM_TEMPLATE: 'SETTING_CHANGE_FORM_TEMPLATE',
    SETTING_CHANGE_FORM_COLOR: 'SETTING_CHANGE_FORM_COLOR',
    /* Shoebox */
    SETTING_READ_ALL_SHOEBOX_CONTACTS_REQUEST: 'SETTING_READ_ALL_SHOEBOX_CONTACTS_REQUEST',
    SETTING_READ_ALL_SHOEBOX_CONTACTS_SUCCESS: 'SETTING_READ_ALL_SHOEBOX_CONTACTS_SUCCESS',
    SETTING_READ_ALL_SHOEBOX_CONTACTS_ERROR: 'SETTING_READ_ALL_SHOEBOX_CONTACTS_ERROR',
    SETTING_UPDATE_SHOEBOX_EMAIL_REQUEST: 'SETTING_UPDATE_SHOEBOX_EMAIL_REQUEST',
    SETTING_UPDATE_SHOEBOX_EMAIL_SUCCESS: 'SETTING_UPDATE_SHOEBOX_EMAIL_SUCCESS',
    SETTING_UPDATE_SHOEBOX_EMAIL_ERROR: 'SETTING_UPDATE_SHOEBOX_EMAIL_ERROR',
    SETTING_UPDATE_SHOEBOX_NUMBER_REQUEST: 'SETTING_UPDATE_SHOEBOX_NUMBER_REQUEST',
    SETTING_UPDATE_SHOEBOX_NUMBER_SUCCESS: 'SETTING_UPDATE_SHOEBOX_NUMBER_SUCCESS',
    SETTING_UPDATE_SHOEBOX_NUMBER_ERROR: 'SETTING_UPDATE_SHOEBOX_NUMBER_ERROR',
    SETTING_SET_SHOEBOX_CONTACT: 'SETTING_SET_SHOEBOX_CONTACT',
    /* Number Format */
    SETTING_NUMBER_READ_ALL_REQUEST: 'SETTING_NUMBER_READ_ALL_REQUEST',
    SETTING_NUMBER_READ_ALL_SUCCESS: 'SETTING_NUMBER_READ_ALL_SUCCESS',
    SETTING_NUMBER_READ_ALL_ERROR: 'SETTING_NUMBER_READ_ALL_ERROR',
    SETTING_NUMBER_UPDATE_ALL_REQUEST: 'SETTING_NUMBER_UPDATE_ALL_REQUEST',
    SETTING_NUMBER_UPDATE_ALL_SUCCESS: 'SETTING_NUMBER_UPDATE_ALL_SUCCESS',
    SETTING_NUMBER_UPDATE_ALL_ERROR: 'SETTING_NUMBER_UPDATE_ALL_ERROR',

    readSettings: request => ({
        type: actions.SETTING_READ_ALL_REQUEST,
        request,
    }),
    updateSettings: request => ({
        type: actions.SETTING_UPDATE_MULTIPLE_REQUEST,
        request,
    }),
    updateApiSettings: request => ({
        type: actions.SETTING_UPDATE_API_REQUEST,
        request,
    }),
    refreshApiToken: () => ({
        type: actions.REFRESH_API_TOKEN_REQUEST,
    }),
    changeSettings: request => ({
        type: actions.SETTING_CHANGE_ALL,
        request,
    }),
    changeSalesTaxOn: salesTaxOn => ({
        type: actions.SETTING_CHANGE_SALES_TAX_ON,
        salesTaxOn,
    }),
    changeServiceTaxOn: serviceTaxOn => ({
        type: actions.SETTING_CHANGE_SERVICE_TAX_ON,
        serviceTaxOn,
    }),
    changeServiceTaxAccrualBasisOn: serviceTaxAccrualBasisOn => ({
        type: actions.SETTING_CHANGE_SERVICE_TAX_ACCRUAL_BASIS_ON,
        serviceTaxAccrualBasisOn,
    }),
    changeShowExemptedTax: showExemptedTax => ({
        type: actions.SETTING_CHANGE_SHOW_EXEMPTED_TAX_CODES,
        showExemptedTax,
    }),
    changeFormTemplate: formTemplate => ({
        type: actions.SETTING_CHANGE_FORM_TEMPLATE,
        formTemplate,
    }),
    changeFormColor: formColor => ({
        type: actions.SETTING_CHANGE_FORM_COLOR,
        formColor,
    }),

    /* Shoebox */
    readAllShoeboxContacts: request => ({
        type: actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_REQUEST,
        request,
    }),
    updateShoeboxEmail: id => ({
        type: actions.SETTING_UPDATE_SHOEBOX_EMAIL_REQUEST,
        id,
    }),
    updateShoeboxNumber: (id, request) => ({
        type: actions.SETTING_UPDATE_SHOEBOX_NUMBER_REQUEST,
        id,
        request,
    }),
    setShoeboxContact: contact => ({
        type: actions.SETTING_SET_SHOEBOX_CONTACT,
        contact,
    }),
    /* Number */
    readNumbers: () => ({
        type: actions.SETTING_NUMBER_READ_ALL_REQUEST,
    }),
    updateNumbers: request => ({
        type: actions.SETTING_NUMBER_UPDATE_ALL_REQUEST,
        request,
    }),
};
export default actions;
